module.exports = __webpack_public_path__ + "media/src/images/changelog_avatar-12c87d16ad34129c28c28b109beb3103.png";